import { createContext, useContext } from "react";
import { UserConfig } from "../../../../types";

type UserConfigContextType = {
  config: UserConfig;
  updateConfig: (config: UserConfig) => Promise<UserConfig>;
};

export const UserConfigContext = createContext<UserConfigContextType>({
  config: {
    exam: {
      auto_next: false,
    },
  },
  updateConfig: (config: UserConfig) => Promise.resolve(config),
});

export const useUserConfig = (): UserConfigContextType => {
  const { config, updateConfig } = useContext(UserConfigContext);
  return { config, updateConfig };
};
